module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[109]230.824348d.woff2";